'use strict';

const _ = require('underscore');
const Page = require('pages/Page/Page.js');
const Constants = require('constants/Constants');
const Events = require('constants/Events');

const IndexHeroCard = require('components/IndexHeroCard/IndexHeroCard');
const IndexHero = require('components/Index/IndexHero/IndexHero');
const IndexFeatures = require('components/Index/IndexFeatures/IndexFeatures');
const IndexTailored = require('components/Index/IndexTailored/IndexTailored');
const IndexResults = require('components/Index/IndexResults/IndexResults');
const IndexPurpleCard = require('components/Index/IndexPurpleCard/IndexPurpleCard');
const IndexPartners = require('components/Index/IndexPartners/IndexPartners');
const IndexInnovating = require('components/Index/IndexInnovating/IndexInnovating');

require('./PageIndex.less');

const ChildViews = {
    'IndexHeroCard': {
        selector: '.IndexHeroCard',
        viewConstructor: IndexHeroCard
    },
    'IndexHero': {
        selector: '.IndexHero',
        viewConstructor: IndexHero
    },
    'IndexTailored': {
        selector: '.IndexTailored',
        viewConstructor: IndexTailored
    },
    'IndexFeatures': {
        selector: '.IndexFeatures',
        viewConstructor: IndexFeatures
    },
    'IndexResults': {
        selector: '.IndexResults',
        viewConstructor: IndexResults
    },
    'IndexPurpleCard': {
        selector: '.IndexPurpleCard',
        viewConstructor: IndexPurpleCard
    },
    'IndexPartners': {
        selector: '.IndexPartners',
        viewConstructor: IndexPartners
    },
    'IndexInnovating': {
        selector: '.IndexInnovating',
        viewConstructor: IndexInnovating
    }
};

const Selectors = {
    overflowWrapper: '.PageIndex-overflowWrapper'
};

const BindFunctions = [
    'toggleOverflow'
];

module.exports = Page.extend({

    events: {},


    initialize: function (options = {}) {
        Page.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);

        if (!app.isPhoneLayout()) {
            this.toggleOverflow(true);
        }

        app.vent.on(Events.home.tailored.cardTransitionBottomUp, () => {
            this.toggleOverflow(true);
        });


        app.vent.on(Events.home.tailored.cardTransitionAfter, () => {
            this.toggleOverflow(false);
        });

        app.vent.on(Events.home.tailored.cardTransitionBottomDown, () => {
            this.toggleOverflow(true);
        });

        this.viewsRegistration(ChildViews);
    },

    toggleOverflow: function (isOverflowHidden) {
        const overflow = isOverflowHidden ? 'hidden' : '';
        this.$(Selectors.overflowWrapper).css(Constants.cssProperties.overflow, overflow);
    }
});
